import { render, staticRenderFns } from "./IndustryOverview.vue?vue&type=template&id=275febf8&scoped=true"
import script from "./IndustryOverview.vue?vue&type=script&lang=js"
export * from "./IndustryOverview.vue?vue&type=script&lang=js"
import style0 from "./IndustryOverview.vue?vue&type=style&index=0&id=275febf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275febf8",
  null
  
)

export default component.exports